import type { IKnowledgeFileSharedNotificationData } from "@frontend-shared/types";
import { FileText } from "lucide-react";
import { memo, useCallback, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";
import { BODY_KEY_BY_SHARE_MODE } from "./constants";

interface IKnowledgeFileSharedCardProps {
  uuid: string;
  data: IKnowledgeFileSharedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewFiles: (targetProjectUuid: string | null) => void;
}

const KnowledgeFileSharedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewFiles,
}: IKnowledgeFileSharedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");
  const bodyKey = useMemo(
    () => BODY_KEY_BY_SHARE_MODE[data.shareMode],
    [data.shareMode],
  );

  const handleViewFiles = useCallback(
    () => onViewFiles(data.targetProjectUuid),
    [onViewFiles, data.targetProjectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="knowledge_file_shared"
      createdAt={createdAt}
      isRead={isRead}
      icon={<FileText className="h-5 w-5 text-sky-500" />}
      iconBgClassName="bg-sky-500/10"
      ctaLabel={t("view_files")}
      onCtaClick={handleViewFiles}
      body={
        <Trans
          ns="notifications"
          i18nKey={bodyKey}
          values={{
            actorName: data.actorName,
            fileName: data.fileName,
            targetProjectTitle: data.targetProjectTitle ?? "",
          }}
          components={{ b: <strong /> }}
        />
      }
    />
  );
};

export const KnowledgeFileSharedCard = memo(KnowledgeFileSharedCardComponent);
